import { render, staticRenderFns } from "./bookerTransfers.vue?vue&type=template&id=2eb1a9ef&scoped=true"
import script from "./bookerTransfers.vue?vue&type=script&setup=true&lang=js"
export * from "./bookerTransfers.vue?vue&type=script&setup=true&lang=js"
import style0 from "./bookerTransfers.vue?vue&type=style&index=0&id=2eb1a9ef&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb1a9ef",
  null
  
)

export default component.exports